// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34cUj","footer":"styles_footer__1zZY0","passCodeTooltip":"styles_passCodeTooltip__I-W7X"};